import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import find from 'lodash/find'
import get from 'lodash/get'
import * as timesheetHelper from '../../helpers/timesheet'
import { statusColor } from '../../helpers/color'
import { FONTS } from '../../../../constants'

export const InfoData = (props) => {
  const { project } = props
  const projects = get(props, 'timesheetRequest.projects', [])
  const projectData = timesheetHelper.findProject(project.project_id, projects)

  return (
    <Row style={ { alignItems: 'flex-start' } }>
      <StatusCol>
        <Detail>{ <Status color={ statusColor(get(project, 'status')) } /> }</Detail>
      </StatusCol>
      <FirstCol>
        <Detail>{ get(projectData, 'project_code') }: { get(projectData, 'name') }</Detail>
      </FirstCol>
    </Row>
  )
}

export const TaskData = (props) => {
  const { task } = props
  let location = find(props.locations, { value: task.location_id })
  if (location === undefined) {
    location = find(props.locations, { code: 'BKK' })
  }
  return (
    <Row>
      <LocationCol>
        <Task>{ get(location, 'label') }</Task>
        <div className='tooltip'>{ get(location, 'label') }</div>
      </LocationCol>
      <TaskCol>
        <Task>{ get(task, 'task_name') }</Task>
        <div className='tooltip'>{ get(task, 'task_name') }</div>
      </TaskCol>
    </Row>
  )
}

InfoData.propTypes = {
  project: PropTypes.object,
}
InfoData.defaultProps = {
  project: {},
}
TaskData.propTypes = {
  task: PropTypes.object,
  locations: PropTypes.array,
}
TaskData.defaultProps = {
  locations: [],
  task: {},
}

const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 15px;
  width: 15px;
  background-color: #D44B49;
  border-radius: 50%;
  margin-top: 3px;
`
const Status = styled(Circle)`
  background-color: ${props => props.color};
  height: 10px;
  width: 10px;
`
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 30%;
  margin-left: 1% !important;
  margin-right: 1% !important;
  cursor: default;

  span {
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    line-height: 40px;
    pointer-events:none;
  }

  span:after {
    content:"";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events:initial;
  }

  .tooltip {
    width: 100%;
    font-size: 12px;
    top: 30px;
    background-color: #fff;
    padding: 5px;
    -webkit-box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }

  span:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    visibility: visible;
  }
`
const FirstCol = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-top: 10px;
`
const StatusCol = styled.div`
  width: 5%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-top: 10px;
`
const TaskCol = styled.div`
  width: 60%;
  font-size: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`
const Detail = styled.p`
  color: #000000;
  margin-bottom: 0px;
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  overflow: hidden;
  cursor: default;
`
const Task = styled.span`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  overflow: hidden;
  margin-bottom: 0px;
  font-weight: normal;
`
const LocationCol = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/info-col.js